import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CampaignsState } from "../types/campaign";
import { SearchDefaultValue, SearchValue } from "./types";

const initialState: CampaignsState = {
  searchValue: SearchDefaultValue,
  isActive: true,
};

export const campaigns = createSlice({
  name: "campaigns",
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<SearchValue>) => {
      state.searchValue.name = action.payload.name;
    },
    setIsActive: (state) => {
      state.isActive = !state.isActive;
    },
  },
});

export const { setSearchValue, setIsActive } = campaigns.actions;

export const selectSearchValue = (state: { campaigns: CampaignsState }) =>
  state?.campaigns?.searchValue;
export const selectIsActive = (state: { campaigns: CampaignsState }) =>
  state?.campaigns?.isActive;

export default campaigns.reducer;
